import { render } from "./FileItemsComponent.vue?vue&type=template&id=3d752556&scoped=true"
import script from "./FileItemsComponent.vue?vue&type=script&lang=js"
export * from "./FileItemsComponent.vue?vue&type=script&lang=js"

import "./FileItemsComponent.vue?vue&type=style&index=0&id=3d752556&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d752556"]])

export default __exports__